export default __webpack_public_path__ + "static/media/gif1_slow.c48e13f0.gif";